import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSketchupComponent } from './simple-icons-sketchup.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSketchupComponent ],
    exports:      [ SimpleIconsSketchupComponent ],
    bootstrap:    []
})
export class SimpleIconsSketchupModule {}
